import { jsx as r, jsxs as u } from "react/jsx-runtime";
import * as t from "@radix-ui/react-dropdown-menu";
import s from "clsx";
import { NavArrowRight as y, Check as w, FilterListCircle as N, Xmark as h } from "iconoir-react";
import * as l from "react";
const p = (e) => s(
  "relative flex min-w-20 cursor-pointer select-none items-center gap-1 rounded px-1 py-1.25 outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-2.5",
  "text-base font-normal leading-[normal]",
  e.inset && "pl-4",
  e.className,
  {
    "focus:bg-surface-100 ": e.color === "default",
    "focus:bg-critical-50 text-critical-600": e.color === "critical",
    "focus:bg-surface-100 bg-primary-50 text-primary-600": e.color === "primary"
  }
), b = (e) => s(
  "relative flex min-w-20 cursor-pointer select-none items-center gap-1 rounded py-1.25 pl-[44px] pr-1 outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-2.5",
  "text-base font-normal leading-[normal]",
  e.inset && "pl-4",
  e.className,
  {
    "focus:bg-surface-100 ": e.color === "default",
    "focus:bg-critical-50 text-critical-600": e.color === "critical",
    "focus:bg-surface-100 bg-primary-50 text-primary-600": e.color === "primary"
  }
), g = (e) => /* @__PURE__ */ r(t.Root, { modal: !1, ...e });
g.displayName = t.Root.displayName;
const G = t.Trigger, L = t.Group, P = t.Portal, A = t.Sub, F = t.RadioGroup, x = l.forwardRef(
  ({
    className: e,
    inset: o,
    children: a,
    color: i = "default",
    startAdornment: n,
    endAdornment: d,
    ...c
  }, m) => /* @__PURE__ */ u(
    t.SubTrigger,
    {
      ref: m,
      onSelect: (f) => {
        f.preventDefault(), c.onSelect && c.onSelect(f);
      },
      className: p({ inset: o, color: i, className: e }),
      ...c,
      children: [
        n,
        a,
        d ?? /* @__PURE__ */ r(y, { className: "ml-auto size-2" })
      ]
    }
  )
);
x.displayName = t.SubTrigger.displayName;
const S = l.forwardRef(({ className: e, ...o }, a) => /* @__PURE__ */ r(
  t.SubContent,
  {
    ref: a,
    className: s(
      "z-dropdown min-w-[8rem] overflow-hidden rounded-md border bg-white-500 p-0.5 text-onSurface-800 shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...o
  }
));
S.displayName = t.SubContent.displayName;
const D = l.forwardRef(({ className: e, sideOffset: o = 4, ...a }, i) => /* @__PURE__ */ r(t.Portal, { children: /* @__PURE__ */ r(
  t.Content,
  {
    ref: i,
    sideOffset: o,
    className: s(
      "z-dropdown min-w-[200px] overflow-hidden rounded-md border bg-white-500 p-0.5 text-onSurface-800 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...a
  }
) }));
D.displayName = t.Content.displayName;
const M = l.forwardRef(
  ({
    className: e,
    inset: o,
    color: a = "default",
    startAdornment: i,
    endAdornment: n,
    ...d
  }, c) => /* @__PURE__ */ u(
    t.Item,
    {
      ref: c,
      onSelect: (m) => {
        d.onSelect && d.onSelect(m);
      },
      className: p({ inset: o, color: a, className: e }),
      ...d,
      children: [
        i,
        d.children,
        n
      ]
    }
  )
);
M.displayName = t.Item.displayName;
const R = l.forwardRef(
  ({ className: e, children: o, checked: a, inset: i, color: n = "default", ...d }, c) => /* @__PURE__ */ u(
    t.CheckboxItem,
    {
      ref: c,
      onSelect: (m) => {
        m.preventDefault(), d.onSelect && d.onSelect(m);
      },
      className: b({ inset: i, color: n, className: e }),
      ...d,
      children: [
        /* @__PURE__ */ r("span", { className: "absolute left-1.75 flex size-2.5 items-center justify-center", children: /* @__PURE__ */ r(
          "div",
          {
            className: s("flex size-2.5 items-center justify-center rounded", {
              "border-2 border-onSurface-400": !a,
              "text-white": a,
              "bg-primary-500": (n === "primary" || n === "default") && a,
              "bg-critical-500": n === "critical" && a
            }),
            children: a && /* @__PURE__ */ r(w, { strokeWidth: 2, className: "size-2.25" })
          }
        ) }),
        o
      ]
    }
  )
);
R.displayName = t.CheckboxItem.displayName;
const z = l.forwardRef(({ className: e, children: o, inset: a, color: i = "default", ...n }, d) => /* @__PURE__ */ u(
  t.RadioItem,
  {
    ref: d,
    className: b({ inset: a, color: i, className: e }),
    ...n,
    children: [
      /* @__PURE__ */ u("span", { className: "absolute left-2 flex size-1.75 items-center justify-center", children: [
        /* @__PURE__ */ r(
          t.ItemIndicator,
          {
            className: "data-[state=checked]:block data-[state=indeterminate]:hidden data-[state=unchecked]:hidden",
            forceMount: !0,
            children: /* @__PURE__ */ r("div", { className: "flex size-2.25 items-center justify-center rounded-full border-2 border-solid border-primary-500 bg-primary-500 ", children: /* @__PURE__ */ r(N, { className: "size-1.5 fill-white text-primary-500" }) })
          }
        ),
        /* @__PURE__ */ r(
          t.ItemIndicator,
          {
            forceMount: !0,
            className: "data-[state=indeterminate]:block data-[state=unchecked]:block data-[state=checked]:hidden",
            children: /* @__PURE__ */ r("div", { className: "size-2.25 rounded-full border-2 border-solid border-onSurface-400 bg-white " })
          }
        )
      ] }),
      o
    ]
  }
));
z.displayName = t.RadioItem.displayName;
const I = l.forwardRef(({ className: e, inset: o, onClose: a, ...i }, n) => /* @__PURE__ */ u(
  t.Label,
  {
    ref: n,
    className: s(
      "flex items-center justify-between px-1.5 py-0.75 text-sm font-semibold",
      o && "pl-4",
      e
    ),
    ...i,
    children: [
      i.children,
      a && /* @__PURE__ */ r("button", { onClick: a, children: /* @__PURE__ */ r(h, { className: "text-primary-500" }) })
    ]
  }
));
I.displayName = t.Label.displayName;
const v = l.forwardRef(({ className: e, ...o }, a) => /* @__PURE__ */ r(
  t.Separator,
  {
    ref: a,
    className: s("my-0.5 h-px bg-onSurface-200", e),
    ...o
  }
));
v.displayName = t.Separator.displayName;
const k = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r(
  "span",
  {
    className: s("ml-auto text-xs tracking-widest opacity-60", e),
    ...o
  }
);
k.displayName = "DropdownMenuShortcut";
export {
  g as DropdownMenu,
  R as DropdownMenuCheckboxItem,
  D as DropdownMenuContent,
  L as DropdownMenuGroup,
  M as DropdownMenuItem,
  I as DropdownMenuLabel,
  P as DropdownMenuPortal,
  F as DropdownMenuRadioGroup,
  z as DropdownMenuRadioItem,
  v as DropdownMenuSeparator,
  k as DropdownMenuShortcut,
  A as DropdownMenuSub,
  S as DropdownMenuSubContent,
  x as DropdownMenuSubTrigger,
  G as DropdownMenuTrigger
};
